import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getShouldHideConsults } from 'store/kits';
import { Kit } from '@repo/types';

export const useShouldShowConsults = (kit?: Kit | null) => {
  const kitId = kit?.id;
  const surveyCompletedDate = kit?.date_survey_completed;
  const resultsReadyDate = kit?.date_results_ready;

  const shouldHideConsults = useSelector(getShouldHideConsults(kitId));

  return useMemo(() => {
    if (!kitId) return false;

    return (
      !shouldHideConsults &&
      !!surveyCompletedDate &&
      !!resultsReadyDate
    );
  }, [
    kitId,
    shouldHideConsults,
    surveyCompletedDate,
    resultsReadyDate,
  ]);
};
